import Commons from '../../../../Services/Common/Common';
import dayjs from 'dayjs';

/**
 * HAZ_BASIC_03 스키마
 */
export const HAZ_BASIC_03_Schema = {
  fields: {
    no: { initial: '', label: 'NO' },
    chaebun: { initial: '', label: '채번' },
    custCd: { initial: '', label: '사업장코드' },
    instrumentName: { initial: '', label: '계측기명', required: 'Y' },
    serialNo: { initial: '', label: 'Serial NO.' },
    qty: { initial: '', label: '수량' },
    spec: { initial: '', label: '규격 (형식/용량 등)' },
    department: { initial: '', label: '담당부서' },
    personInCharge: { initial: '', label: '담당자' },
    receivingDate: { initial: '', label: '입고일자' },
    measurementCycle: { initial: '', label: '검교정 주기' },
    calibrationDate: { initial: '', label: '검교정일자' },
    nextCalibrationDate: { initial: '', label: '차기 교정일자' },
    calibrationAgency: { initial: '', label: '검교정 기관' },
    remark: { initial: '', label: '비고' },
    alarmYn: { initial: '', label: '알람여부 (Y/N)', required: 'Y' },
    alarmId: { initial: '', label: '알람ID' },
    instrumentImageFileName: { initial: '', label: '계측기 이미지 파일명' },
    instrumentImageSaveName: { initial: '', label: '계측기 이미지 저장명' },
    instrumentImageFilePath: { initial: '', label: '계측기 이미지 파일 경로' },
    previewFilePath: { initial: '', label: '미리보기 파일 경로' },
  },

  mapper: {
    search1: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      Year: (_, context) =>
        Commons.EncryptAES(context.search?.year || '') || '',
    },
    search2: {
      UserId: (_, context) => context.userInfo?.userid || '',
    },
    delete1: {
      Chaebun: (row) => Commons.EncryptAES(row.chaebun || '') || '',
      AlarmId: (row) =>
        Commons.EncryptAES(row.alarmId ? row.alarmId.toString() : '0') || '',
    },
    save1: {
      Chaebun: (row) => {
        const chaebun = row.chaebun;
        const chaebunValue =
          chaebun && chaebun.toString().trim() !== '' ? chaebun.toString() : '0';
        return Commons.EncryptAES(chaebunValue) || '';
      },
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      InstrumentName: (row) => Commons.EncryptAES(row.instrumentName || '') || '',
      SerialNo: (row) => Commons.EncryptAES(row.serialNo || '') || '',
      Qty: (row) => Commons.EncryptAES(row.qty || '') || '',
      Spec: (row) => Commons.EncryptAES(row.spec || '') || '',
      Department: (row) => Commons.EncryptAES(row.department || '') || '',
      PersonInCharge: (row) => Commons.EncryptAES(row.personInCharge || '') || '',
      ReceivingDate: (row) => {
        if (!row.receivingDate || !dayjs(row.receivingDate).isValid()) return '';
        return Commons.EncryptAES(dayjs(row.receivingDate).format('YYYY-MM-DD')) || '';
      },
      MeasurementCycle: (row) => Commons.EncryptAES(row.measurementCycle || '') || '',
      CalibrationDate: (row) => {
        if (!row.calibrationDate || !dayjs(row.calibrationDate).isValid()) return '';
        return Commons.EncryptAES(dayjs(row.calibrationDate).format('YYYY-MM-DD')) || '';
      },
      NextCalibrationDate: (row) => {
        if (!row.nextCalibrationDate || !dayjs(row.nextCalibrationDate).isValid()) return '';
        return Commons.EncryptAES(dayjs(row.nextCalibrationDate).format('YYYY-MM-DD')) || '';
      },
      CalibrationAgency: (row) => Commons.EncryptAES(row.calibrationAgency || '') || '',
      Remark: (row) => Commons.EncryptAES(row.remark || '') || '',
      InstrumentImageFileName: (row) =>
        Commons.EncryptAES(row.instrumentImageFileName || '') || '',
      InstrumentImageSaveName: (row) =>
        Commons.EncryptAES(row.instrumentImageSaveName || '') || '',
      InstrumentImageFilePath: (row, context) => {
        // 새 파일 업로드 시: previewFilePath에서 saveName 추출하여 최종 경로 생성
        const previewPath = row.previewFilePath || '';
        if (previewPath) {
          const saveName = previewPath.split('/').pop() || '';
          const finalPath = `HazardousMachines/${context.search?.custCd}/HAZ_BASIC_03/${saveName}`;
          return Commons.EncryptAES(finalPath) || '';
        }

        // 기존 파일 유지 시: instrumentImageFilePath 직접 사용
        const existingFilePath = row.instrumentImageFilePath || '';
        if (!existingFilePath) return '';
        return Commons.EncryptAES(existingFilePath) || '';
      },
      AlarmId: (row) =>
        Commons.EncryptAES(row.alarmId ? row.alarmId.toString() : '0') || '',
      AlarmYn: (row) => Commons.EncryptAES(row.alarmYn || 'N') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },
    save2: {
      AlarmId: (row) =>
        Commons.EncryptAES(row.alarmId ? row.alarmId.toString() : '0') || '',
      CalId: (row) => Commons.EncryptAES(row.calId ? row.calId.toString() : '') || '',
      ValidityDate: (row) => {
        if (!row.nextCalibrationDate || !dayjs(row.nextCalibrationDate).isValid()) return '';
        return Commons.EncryptAES(dayjs(row.nextCalibrationDate).format('YYYY-MM-DD')) || '';
      },
      AlarmYn: (row) => Commons.EncryptAES(row.alarmYn || 'N') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },
  },
};
